export default __webpack_public_path__ + "static/media/hht2_ep16_timeline_q01_b.9db63b5d.png";